import './Subiecte.css';

export default function Subiecte2023() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2023{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectAugust2023MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectAugust2023MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremAugust2023MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectAugust2023SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectAugust2023SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremAugust2023SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectIunie2023MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectIunie2023MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremIunie2023MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectIunie2023SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectIunie2023SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremIunie2023SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectSpeciala2023MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2023/BaremSpeciala2023MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectSimulare2023MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectSimulare2023MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremSimulare2023MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectSimulare2023SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectSimulare2023SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremSimulare2023SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectModel2023MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectModel2023MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremModel2023MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2023/SubiectModel2023SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2023/SubiectModel2023SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2023/BaremModel2023SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}